"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var polished_1 = require("polished");
var styled_components_1 = __importStar(require("../../Themes/styled-components"));
var Label_1 = __importDefault(require("../components/Label"));
var Icon_1 = __importDefault(require("../../Icon"));
var Wrapper = styled_components_1.default('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  padding: 0.2em 0.8em;\n  align-items: center;\n  border-radius: ", ";\n  max-width: 100%;\n  vertical-align: middle;\n  margin: ", ";\n  ", "\n"], ["\n  display: inline-flex;\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  padding: 0.2em 0.8em;\n  align-items: center;\n  border-radius: ", ";\n  max-width: 100%;\n  vertical-align: middle;\n  margin: ", ";\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primaryBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, polished_1.rem(12), polished_1.rem(4), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.select.padding);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.separatorColor;
    });
});
var RemoveBtn = styled_components_1.default('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0;\n  padding-left: 3px;\n"], ["\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0;\n  padding-left: 3px;\n"])));
exports.default = styled_components_1.withTheme(function (props) {
    return (React.createElement(Wrapper, { disabled: props.disabled },
        React.createElement(Label_1.default, { label: props.value.label, icon: props.value.icon, iconSize: 12 }),
        props.onRemove && (React.createElement(RemoveBtn, { onClick: props.onRemove },
            React.createElement(Icon_1.default, { name: "close", color: props.theme.color.primary })))));
});
var templateObject_1, templateObject_2, templateObject_3;
